import {_axios} from '../../plugins/axios';
import { useEffect, useState } from 'react';
import { Modal} from 'react-bootstrap';
import Collapse from 'rc-collapse';
require('rc-collapse/assets/index.css');
const Panel = Collapse.Panel;
import loader from '../../assets/Loading_icon.gif'
import { URL, USER } from "../../constants/constant";

export default function PackageDetails({ showPackageInfoModal, showPackageInfo, appointmentId, packageName }){

    const [allPackages, setAllPackages] = useState([])
    const [packageTitle, setPackageTitle] = useState([])
    const [loading, setLoading] = useState(true)
    const [totalTest, setTotalTests] = useState(0)

    useEffect(() => {
        getPackages()
    },[])

    async function getPackages(){
        try {
            const payload = {
                appointmentId: appointmentId
            }
            const res = await _axios.post(`${URL.dev_url}packageInfo`, payload)
            if(res.data.success){
                setAllPackages(res.data.packages)
                setPackageTitle(Object.keys(res.data.packages))
            }
            let keys = Object.keys(res.data.packages)
            let total = 0
            for(let i = 0; i < keys.length; i++){
                total += res.data.packages[keys[i]].length
            }
            setTotalTests(total)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

        return (
            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={showPackageInfo}
                onHide={() => showPackageInfoModal()}
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Package Details
                        <div className='packageTotalCount'>
                            {totalTest} Lab Tests in {packageName}
                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{height:"550px",padding:'5px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "10px"}}>
                {loading ? <img src={loader} /> : 
                    <Collapse accordion={true}>
                        {packageTitle.map((data, i) =>{
                            return (
                                <Panel header={data + " (" + allPackages[data].length + " Tests)"} style={{fontWeight: "bold"}}>
                                    {allPackages[data].length > 0 ? allPackages[data].map((data,j) =>{
                                            return (
                                                <div key={j} style={{padding: "4px 0", fontWeight: "300px !important"}}>
                                                    {j+1}.{data.packageName}
                                                </div>
                                            )
                                    }) : <p>No Tests found</p>}
                                </Panel>
                            )
                        })}
                    </Collapse>
                }
                
                
                    
                </Modal.Body>
            </Modal>
        )
    
}